const baseStyleContent = {
  bg: `surfaceElevated1`,
  width: "auto",
  // border: "1px solid",
  // borderColor: "inherit",
  borderRadius: "8px",
  boxShadow:
    "0 15px 20px 0 rgba(0, 0, 0, 0.15), 0 0 10px 0 rgba(0, 0, 0, 0.08)",
  zIndex: "inherit",
  _focusVisible: {
    outline: 0
  }
};

// const baseStyleBody = {
//   px: 3,
//   py: 2
// };

const baseStyle = {
  content: baseStyleContent,
  popper: {
    zIndex: 999
  }
  // body: baseStyleBody
};

const popover = {
  baseStyle
};

export default popover;
